import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Koregaonparktomumbaicab() {



const cardData = {
  keyword: " Koregaon Park to Mumbai Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Koregaon Park to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Koregaon Park to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is your trusted choice for Koregaon Park to Mumbai cab travel.",

topPlaces: [

  {
    title: "Aksa Beach",
    description: "Aksa Beach offers a quieter alternative to Mumbai's crowded beaches and is perfect for a relaxing coastal getaway. Travelers renting an Innova Crysta in Pune can comfortably reach this scenic destination and enjoy peaceful walks, stunning sunsets, and quality time with family or friends."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Visitors booking an Innova Crysta on rent in Pune can explore this heritage site while enjoying panoramic views of the Bandra-Worli Sea Link and Mumbai's beautiful coastline."
  },
  {
    title: "Phoenix Marketcity",
    description: "Phoenix Marketcity is one of Mumbai's largest shopping malls, offering premium brands, fine dining restaurants, entertainment zones, and multiplex cinemas. Choosing an Innova Crysta on rent in Pune makes the journey convenient for families and groups planning a day filled with shopping and entertainment."
  },
    {
    title: "Crawford Market",
    description: "Crawford Market is one of Mumbai's oldest and busiest shopping destinations, known for fresh produce, spices, dry fruits, handicrafts, and imported goods. Travelers booking an Innova Crysta on rent in Pune can comfortably reach this vibrant marketplace and enjoy shopping while experiencing the city's rich colonial heritage and bustling local culture."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is among Mumbai's most visited spiritual landmarks dedicated to Lord Ganesha. Renting an Innova Crysta in Pune offers a comfortable journey for families and devotees traveling to seek blessings. The temple's peaceful atmosphere and beautiful architecture make it a must-visit destination during a Mumbai trip."
  },
  {
    title: "Versova Beach",
    description: "Versova Beach is known for its peaceful shoreline, relaxing atmosphere, and beautiful Arabian Sea sunsets. Travelers choosing an Innova Crysta on rent in Pune can enjoy a scenic drive before spending quality time walking along the beach, tasting local seafood, and capturing memorable photographs."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya",
    description: "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya is one of India's finest museums, featuring thousands of historical artifacts, sculptures, paintings, and rare collections. Visitors hiring an Innova Crysta on rent in Pune can comfortably explore this cultural landmark while learning about India's fascinating artistic and historical heritage."
  },
  {
    title: "Nariman Point",
    description: "Nariman Point is a popular waterfront destination and one of Mumbai's most prestigious commercial areas. Booking an Innova Crysta on rent in Pune allows travelers to enjoy a relaxing road trip before admiring spectacular sea views, modern skyscrapers, and the beautiful promenade overlooking the Arabian Sea."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's iconic waterfront monument and a favorite attraction for tourists from across the country. Travelers hiring an Innova Crysta on rent in Pune can comfortably visit this historic landmark, enjoy ferry rides, admire colonial architecture, and experience the vibrant atmosphere along the Mumbai harbor."
  },
  {
    title: "Banganga Tank",
    description: "Banganga Tank is an ancient sacred water tank surrounded by historic temples and narrow heritage lanes. Renting an Innova Crysta in Pune allows visitors to comfortably explore this peaceful destination while discovering one of Mumbai's oldest religious and cultural landmarks, known for its timeless charm and spiritual significance."
  }
],



services: [
{
name: "Koregaon Park to Mumbai Airport Cab",
description: "Koregaon Park to Mumbai Airport cab service provides reliable transportation for travelers heading from Koregaon Park in Pune to Mumbai Airport terminals. Comfortable vehicles with professional drivers ensure safe and timely journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, hotels, restaurants, and offices across Koregaon Park. Ideal for business travelers, tourists, and families."
},
{
name: "Koregaon Park to Mumbai International Airport Cab",
description: "Koregaon Park to Mumbai International Airport cab service offers dependable airport transfers to Chhatrapati Shivaji Maharaj International Airport. Vehicles provide comfortable seating and luggage space suitable for international travel. Professional drivers ensure punctual pickup and safe highway driving. Pickup services are available across Koregaon Park."
},
{
name: "Koregaon Park to Mumbai Airport Drop Taxi",
description: "Koregaon Park to Mumbai Airport drop taxi service provides convenient one-way transportation for passengers traveling to Mumbai Airport. Vehicles are comfortable and suitable for long-distance highway travel. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, and offices in Koregaon Park."
},
{
name: "Koregaon Park to Mumbai Airport One Way Taxi",
description: "Koregaon Park to Mumbai Airport one way taxi service offers flexible transportation for travelers planning direct airport drops. Comfortable vehicles and experienced drivers ensure safe expressway travel. Pickup services are available across Koregaon Park residential and commercial areas."
},
{
name: "Koregaon Park to Mumbai Round Trip Cab",
description: "Koregaon Park to Mumbai round trip cab service provides convenient same-day or multi-day travel options between Pune and Mumbai. Vehicles are comfortable and suitable for long-distance travel with experienced drivers ensuring safe journeys."
},
{
name: "Cab Service in Koregaon Park",
description: "Cab service in Koregaon Park offers reliable transportation for local rides, airport transfers, and outstation journeys. Vehicles are well maintained and suitable for city travel and long-distance trips. Professional drivers ensure safe and smooth rides across Koregaon Park and Pune."
},
{
name: "Koregaon Park to Santacruz Cab Fare",
description: "Koregaon Park to Santacruz cab fare services provide transparent pricing for passengers traveling between Koregaon Park in Pune and Santacruz in Mumbai. Travelers can choose sedan, Ertiga, or Innova vehicles depending on comfort and budget."
},
{
name: "Koregaon Park to Mumbai Central Cab",
description: "Koregaon Park to Mumbai Central cab service offers reliable transportation for travelers heading to Mumbai Central railway station. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport journeys."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for travelers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for expressway travel."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality suitable for expressway journeys."
},
{
name: "Taxi Cab Service in Koregaon Park",
description: "Taxi cab service in Koregaon Park provides dependable transportation for passengers traveling within Pune and nearby cities. Vehicles are comfortable and suitable for daily commuting, airport transfers, and outstation journeys."
},
{
name: "Koregaon Park to Navi Mumbai Cab",
description: "Koregaon Park to Navi Mumbai cab service offers reliable transportation between Pune and Navi Mumbai. Vehicles are comfortable and suitable for long-distance highway travel with professional drivers ensuring safe journeys."
},
{
name: "Koregaon Park to Airport Cab Service",
description: "Koregaon Park to airport cab service offers dependable transportation for passengers traveling to Pune Airport or Mumbai Airport. Vehicles are comfortable and suitable for airport travel with luggage capacity."
},
{
name: "Koregaon Park to Thane Cab Service",
description: "Koregaon Park to Thane cab service provides convenient transportation between Pune and Thane city. Vehicles are comfortable and suitable for expressway travel with experienced drivers ensuring safe journeys."
},
{
name: "Koregaon Park to Mumbai Airport Innova",
description: "Koregaon Park to Mumbai Airport Innova cab service offers premium SUV transportation for airport transfers. Innova vehicles provide spacious seating and luggage capacity suitable for airport travelers."
},
{
name: "Innova Crysta on Rent in Koregaon Park",
description: "Innova Crysta on rent in Koregaon Park provides luxury SUV rental for travelers seeking premium transportation. The Innova Crysta offers spacious seating and smooth ride quality suitable for long-distance journeys."
},
{
name: "7 Seater Car on Rent in Koregaon Park",
description: "7 seater car on rent in Koregaon Park offers spacious vehicles suitable for family trips and group travel. Comfortable seating and luggage capacity make these vehicles ideal for airport transfers and outstation journeys."
},
{
name: "Ertiga on Rent in Koregaon Park",
description: "Ertiga on rent in Koregaon Park provides comfortable SUV transportation suitable for families and small groups. The vehicle offers spacious seating and smooth highway travel performance."
},
{
name: "Luxury Car on Rent in Koregaon Park",
description: "Luxury car on rent in Koregaon Park offers premium vehicle rental for corporate travel, weddings, and special occasions. Stylish vehicles with comfortable interiors ensure luxurious travel experiences."
},
{
name: "Pune Mumbai Velocity Cabs",
description: "Pune Mumbai Velocity Cabs service offers dependable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers ensuring safe journeys via the expressway."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for city rides, airport transfers, and outstation travel. Comfortable vehicles and professional drivers ensure safe and smooth journeys across Pune."
}
],

tableData: [
["Koregaon Park to Mumbai Airport Cab","Koregaon Park to Mumbai International Airport Cab"],
["Koregaon Park to Mumbai Airport Drop Taxi","Koregaon Park to Mumbai Airport One Way Taxi"],
["Koregaon Park to Mumbai Round Trip Cab","Cab Service in Koregaon Park"],
["Koregaon Park to Santacruz Cab Fare","Koregaon Park to Mumbai Central Cab"],
["Pune to Mumbai Airport Cab","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Taxi Cab Service in Koregaon Park"],
["Koregaon Park to Navi Mumbai Cab","Koregaon Park to Airport Cab Service"],
["Koregaon Park to Thane Cab Service","Koregaon Park to Mumbai Airport Innova"],
["Innova Crysta on Rent in Koregaon Park","7 Seater Car on Rent in Koregaon Park"],
["Ertiga on Rent in Koregaon Park","Luxury Car on Rent in Koregaon Park"],
["Pune Mumbai Velocity Cabs","Cab Service in Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Koregaon Park to Mumbai via the Mumbai Pune Expressway. Their knowledge of traffic routes and highway driving ensures a safe and smooth intercity journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Koregaon Park to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Koregaon Park to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Koregaon Park to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Koregaon Park",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, restaurants, and commercial locations across Koregaon Park and nearby areas like Kalyani Nagar, Viman Nagar, Yerawada, and Bund Garden."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Koregaon Park to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Koregaon Park to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Koregaon Park to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Koregaon Park to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Koregaon Park to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Koregaon Park to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Koregaon Park and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and commercial locations across Koregaon Park." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Koregaon Park to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback:
      "Comfortable and well-managed travel experience from Koregaon Park to Mumbai. The cab was punctual, clean, and the ride felt smooth throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback:
      "The journey from Koregaon Park to Mumbai was very convenient. The vehicle was in great condition, the drive was steady, and everything was handled professionally.",
    rating: 5
  }
];








































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Koregaon Park to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Koregaon Park to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Innova Crysta for airport transfers, Santacruz, Mumbai Central, Navi Mumbai, Thane, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Koregaon Park to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Koregaon Park to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Koregaon Park to Mumbai cab with Velocity Cabs. Affordable taxi service for one way, round trip & airport drop. Ertiga, Innova & Crysta cabs available for Santacruz, Mumbai Central, Navi Mumbai & Thane." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Koregaonparktomumbaicab;